
































































































































































import axios from 'axios';
import { get } from 'lodash';

import { User } from '@/components/Molecules/co-card-member/models.ts';
import CoDropdown from '@/components/Molecules/co-dropdown/CoDropdown.vue';
import CoDropdownItem from '@/components/Molecules/co-dropdown-item/CoDropdownItem.vue';
import CoCardMember from '@/components/Molecules/co-card-member/CoCardMember.vue';
import CoCard from '@/components/Molecules/co-card/CoCard.vue';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoIcon from '@/components/Atoms/co-icon/CoIcon.vue';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoUserInvite from '@/components/Organisms/co-user-invite/CoUserInvite.vue';
import CoRoundButton from '@/components/Atoms/co-round-button/CoRoundButton.vue';
import CoTippy from '@/components/Atoms/co-tippy/CoTippy.vue';
import CoUserCreateAdminModal from '@/components/Organisms/co-user-create-admin-modal/CoUserCreateAdminModal.vue';
import EventBus from '../../eventBus';
import { getOnlineUserIds } from '../../utils/realtimePresence';

interface PresenceUpdate {
    userId: string;
    online: boolean;
    changedAt?: number | string | null;
}

export default {
    name: 'CommunityMembers',
    components: {
        CoCardMember,
        CoCard,
        CoDropdown,
        CoDropdownItem,
        CoButton,
        CoText,
        CoIcon,
        CoHeadline,
        CoUserInvite,
        CoRoundButton,
        CoTippy,
        CoUserCreateAdminModal,
    },
    i18n: {
        messages: {
            en: {
                labels: {
                    sortingByRelevance: 'Relevance',
                    sortingByLastActivity: 'Last Activity',
                    scopeMyCommunity: 'My Community',
                    scopeConnected: 'Connected Communities',
                },
            },
            de: {
                labels: {
                    sortingByRelevance: 'Relevanz',
                    sortingByLastActivity: 'Letzte Aktivität',
                    scopeMyCommunity: 'Meine Community',
                    scopeConnected: 'Verbundene Communities',
                },
            },
        },
    },
    data() {
        return {
            feed: [] as User[],
            activeMembers: [] as User[],
            onlineMembers: [] as User[],
            feedNextPage: null, // used for single community
            loading: true,
            nextParams: null, // used for circles
            feedRequestId: 0, // helps ignore stale async responses
            presenceUpdateTimeout: null,
            pendingPresenceUpdates: new Map<string, PresenceUpdate>(),

            isCirclesOn: this.$store.state.circlesOn,
            // by default set to true if isCirclesOn is true, can be set to false. Only used for spaces within circles
            listingScopeConnnected: false,
            sortBy: 'score', // default sort by lastactivity can be changed to Score
            isAdmin: this.$store?.state?.me?.Permissions?.includes('space_admin') || false,
            showSettings: false,
            configLoading: false,
            signupStrategy: null,
        };
    },
    watch: {
        $route(to) {
            // listingScopeConnnected
            // get scope from route query params
            if (to.query && to.query.scope) {
                if (to.query.scope === 'connected') {
                    this.listingScopeConnnected = true;
                    this.sortBy = get(to, 'query.sortBy', 'lastactivity');
                    this.feed = [];
                    this.activeMembers = [];
                    this.feedNextPage = null;
                    this.nextParams = null;
                    this.loading = true;
                    this.getCommunityForCircle();
                } else {
                    this.listingScopeConnnected = false;
                    this.sortBy = get(to, 'query.sortBy', 'score');
                    this.feed = [];
                    this.activeMembers = [];
                    this.feedNextPage = null;
                    this.nextParams = null;
                    this.loading = true;
                    this.getCommunity();
                }
            }
        },
    },
    created() {
        if (this.$route.query && this.$route.query.scope) {
            this.sortBy = get(this.$route, 'query.sortBy', 'score');

            if (this.$route.query.scope === 'my-community') {
                this.listingScopeConnnected = false;
            } else {
                this.listingScopeConnnected = true;
            }
        } else {
            // default to my-community
            this.listingScopeConnnected = false;
            this.setScope('my-community');
            this.setSortingBy('score');
        }
        window.addEventListener('scroll', this.scroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.scroll);
        EventBus.$off('USER_PRESENCE_UPDATED', this.handlePresenceUpdated);
        if (this.presenceUpdateTimeout) {
            clearTimeout(this.presenceUpdateTimeout);
        }
    },
    mounted() {
        EventBus.$on('USER_PRESENCE_UPDATED', this.handlePresenceUpdated);
        if (this.isCirclesOn && this.listingScopeConnnected) {
            this.nextParams = null;
            this.getCommunityForCircle();
        } else {
            this.feedNextPage = null;
            this.getCommunity();
        }
        if (this.isAdmin) {
            // fetch signup strategy config
            this.getAuthFlowConfig();
        }
    },
    computed: {
        me() {
            return this.$store.state.me;
        },
        listingScopeLabel() {
            if (this.listingScopeConnnected) {
                return this.$t('labels.scopeConnected');
            }
            return this.$t('labels.scopeMyCommunity');
        },
        sortByLabel() {
            if (this.sortBy === 'score') {
                return this.$t('labels.sortingByRelevance');
            }
            return this.$t('labels.sortingByLastActivity');
        },
        isMatchingEnabledForSpace() {
            if (!this.$store || !this.$store.state || !this.$store.state.space) {
                return false;
            }

            return !this.$store.state.space.MatchingOff;
        },
    },
    methods: {
        setSortingBy(sortBy) {
            this.sortBy = sortBy;

            if (this.sortBy === 'score') {
                const queryParam = { ...this.$route.query, scope: 'my-community', sortBy: 'score' };
                this.$router.push({ query: queryParam });
            } else {
                const queryParam = { ...this.$route.query, sortBy: 'lastactivity' };
                this.$router.push({ query: queryParam });
            }
        },
        setScope(scope) {
            if (scope === 'my-community') {
                const queryParam = { ...this.$route.query, scope: 'my-community' };
                this.$router.push({ query: queryParam });
            } else {
                const queryParam = { ...this.$route.query, scope: 'connected', sortBy: 'lastactivity' };
                this.$router.push({ query: queryParam });
            }
        },
        shouldPrioritizeOnlineMembers() {
            return this.sortBy === 'lastactivity';
        },
        isAvailableMember(member) {
            return Number(member?.status) !== -1;
        },
        dedupeMembersById(members: User[] = []) {
            const seenUserIds = new Set();

            return members.filter((member) => {
                if (!this.isAvailableMember(member)) return false;

                const userId = String(member?.id || '');
                if (!userId || seenUserIds.has(userId)) return false;

                seenUserIds.add(userId);
                return true;
            });
        },
        refreshFeedFromActiveMembers() {
            this.activeMembers = this.dedupeMembersById(this.activeMembers);
            this.feed = [...this.activeMembers];
        },
        async listMembersByIds(userIds: Array<string | number> = []): Promise<User[]> {
            const uniqueUserIds = Array.from(new Set(userIds.map((userId) => String(userId)).filter(Boolean)));
            if (uniqueUserIds.length === 0) return [];

            const ids = JSON.stringify({ IDS: uniqueUserIds.map((ID) => ({ ID })) });
            const response = await this.$store.dispatch('listUsersByIDs', { ids });

            return (response?.Users || []).map((user) => this.memberFromUser(user));
        },
        normalizePresenceTimestamp(changedAt, fallbackTimestamp: number | string | null = null) {
            const normalizedTimestamp = Number(changedAt);

            if (Number.isFinite(normalizedTimestamp) && normalizedTimestamp > 0) {
                return normalizedTimestamp;
            }

            return fallbackTimestamp;
        },
        indexAfterOnlineMembers(members: User[]) {
            const onlineUserIds = new Set(getOnlineUserIds().map(String));

            return members.findIndex((member) => !onlineUserIds.has(String(member?.id)));
        },
        applyPresenceUpdateToMembers(
            members: User[],
            presenceUpdate: PresenceUpdate,
            fetchedMembersById: Map<string, User> = new Map<string, User>()
        ) {
            const normalizedUserId = String(presenceUpdate?.userId || '');
            if (!normalizedUserId) return members;

            const existingIndex = members.findIndex((member) => String(member?.id) === normalizedUserId);
            const existingMember = existingIndex >= 0 ? members[existingIndex] : null;
            const fetchedMember = fetchedMembersById.get(normalizedUserId) || null;
            let member = null;

            if (existingMember) {
                member = { ...existingMember };
            } else if (fetchedMember) {
                member = { ...fetchedMember };
            }

            if (!member) {
                return members;
            }

            const nextMembers = [...members];
            if (existingIndex >= 0) {
                nextMembers.splice(existingIndex, 1);
            }

            if (!this.isAvailableMember(member)) {
                return nextMembers;
            }

            const lastActivity = this.normalizePresenceTimestamp(
                presenceUpdate?.changedAt,
                member.lastActivity || null
            );
            if (lastActivity !== null) {
                member.lastActivity = lastActivity;
            }

            if (presenceUpdate?.online) {
                // Keep the most recently active online member at the top of the list.
                nextMembers.unshift(member);
                return nextMembers;
            }

            // Offline members stay below the online block, newest offline first.
            const firstOfflineIndex = this.indexAfterOnlineMembers(nextMembers);
            const insertionIndex = firstOfflineIndex === -1 ? nextMembers.length : firstOfflineIndex;
            nextMembers.splice(insertionIndex, 0, member);

            return nextMembers;
        },
        async flushPresenceUpdates() {
            const queuedPresenceUpdates: PresenceUpdate[] = Array.from(this.pendingPresenceUpdates.values());
            this.pendingPresenceUpdates.clear();

            if (queuedPresenceUpdates.length === 0 || !this.shouldPrioritizeOnlineMembers()) {
                return;
            }

            const missingOnlineUserIds = queuedPresenceUpdates
                .filter((update) => update?.online)
                .map((update) => String(update?.userId || ''))
                .filter((userId) => userId && !this.activeMembers.some((member) => String(member?.id) === userId));
            const fetchedMembers = await this.listMembersByIds(missingOnlineUserIds);
            const fetchedMembersById = new Map<string, User>(
                fetchedMembers.filter((member) => member?.id).map((member) => [String(member.id), member])
            );

            let nextMembers = [...this.activeMembers];

            queuedPresenceUpdates.forEach((update) => {
                nextMembers = this.applyPresenceUpdateToMembers(nextMembers, update, fetchedMembersById);
            });

            this.activeMembers = nextMembers;
            this.refreshFeedFromActiveMembers();
        },

        getCommunityForCircle() {
            this.loading = true;
            this.feedRequestId += 1;
            const requestId = this.feedRequestId;
            const isFirstPage = !this.nextParams;
            const data = {
                Params: this.nextParams,
            };

            if (isFirstPage) {
                this.activeMembers = [];
                this.refreshFeedFromActiveMembers();
            }

            axios({
                method: 'POST',
                url: '/user/profile/list/circles',
                data: JSON.stringify(data),
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (requestId !== this.feedRequestId) {
                        return;
                    }

                    if (response && response.data && response.data.Objects) {
                        let objs = response.data.Objects;
                        // sort objs by score
                        objs = objs.sort((a, b) => b.object.LastActivity - a.object.LastActivity);

                        // map feed items to Page type
                        const tmp = objs.map((item) => this.memberFromItem(item));

                        this.activeMembers = [...this.activeMembers, ...tmp];
                        this.refreshFeedFromActiveMembers();
                        this.nextParams = get(response, 'data.NextParams', null);
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    if (requestId === this.feedRequestId) {
                        this.loading = false;
                    }
                });
        },
        getCommunity() {
            this.loading = true;
            this.feedRequestId += 1;
            const requestId = this.feedRequestId;
            const isFirstPage = !this.feedNextPage;
            let url = '/user/profile/list';

            if (!this.listingScopeConnnected && this.sortBy === 'score') {
                url = '/user/profile/list?sortby=Score&direction=desc';
            }

            if (isFirstPage) {
                this.activeMembers = [];
                this.refreshFeedFromActiveMembers();
            }

            if (this.feedNextPage) {
                url = this.feedNextPage;
            }
            axios({
                method: 'GET',
                url,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (requestId !== this.feedRequestId) {
                        return;
                    }

                    this.feedNextPage = response.data.next ? response.data.next : null;
                    if (!response.data.objects) return;

                    // map feed items to Page type
                    const tmp = response.data.objects.map((item) => this.memberFromItem(item));
                    this.activeMembers = [...this.activeMembers, ...tmp];
                    this.refreshFeedFromActiveMembers();
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    if (requestId === this.feedRequestId) {
                        this.loading = false;
                    }
                });
        },
        scroll() {
            // Fetch the next page only when the viewport reaches the final 10% of the document.
            const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
            if (scrollableHeight <= 0 || window.scrollY < scrollableHeight * 0.9 || this.loading) return;

            if (this.isCirclesOn && this.listingScopeConnnected) {
                if (this.nextParams != null) this.getCommunityForCircle();
            } else if (this.feedNextPage != null) {
                this.getCommunity();
            }
        },
        mapMemberSpace(spaceItem) {
            if (!spaceItem || !spaceItem.ID || spaceItem.ID === this.$store.state.space.ID) {
                return null;
            }

            // Keep the source-space matching preference with the instance metadata.
            return {
                id: spaceItem.ID,
                name: spaceItem.Name,
                favicon: spaceItem.FaviconURL,
                primaryColor: spaceItem.PrimaryColor,
            };
        },
        memberFromItem(item) {
            return this.memberFromUser(item?.object || {}, item?.space);
        },
        memberFromUser(user, spaceItem = null) {
            const profile = user?.Profile || {};
            const member: User = {
                id: user.ID,
                name: profile.Name || user.Name,
                headline: profile.Bio || user.Bio,
                image: profile.ImageURL || user.ImageURL,
                slug: user.Slug,
                status: user.Status,
                score: this.memberScoreFromItem({ object: user }),
            };

            const lastActivity = this.normalizePresenceTimestamp(user?.LastActivity, null);
            if (lastActivity !== null) {
                member.lastActivity = lastActivity;
            }

            if (spaceItem && spaceItem.ID) {
                member.space = this.mapMemberSpace(spaceItem);
            }

            return member;
        },
        memberScoreFromItem(item) {
            // Community list endpoints can place the match score either on the wrapper or the user object.
            const scoreCandidates = [
                get(item, 'Score'),
                get(item, 'score'),
                get(item, 'object.Score'),
                get(item, 'object.score'),
                get(item, 'object.Profile.Score'),
            ];
            const score = scoreCandidates.find((value) => value !== null && value !== undefined && value !== '');

            if (score === null || score === undefined || score === '') {
                return null;
            }

            const numericScore = Number(score);

            return Number.isNaN(numericScore) ? null : numericScore;
        },
        handlePresenceUpdated(presenceUpdate: PresenceUpdate) {
            if (!this.shouldPrioritizeOnlineMembers() || !presenceUpdate?.userId) return;

            this.pendingPresenceUpdates.set(String(presenceUpdate.userId), presenceUpdate);

            if (this.presenceUpdateTimeout) {
                clearTimeout(this.presenceUpdateTimeout);
            }

            // Batch bursty snapshot updates into one lookup before reordering the community list.
            this.presenceUpdateTimeout = window.setTimeout(() => {
                this.presenceUpdateTimeout = null;
                this.flushPresenceUpdates().catch((error) => {
                    console.log(error);
                });
            }, 100);
        },
        sendMessage(userObj) {
            if (!userObj || !userObj.id) return;
            const thread = {
                Participants: [this.me.ID, userObj.id],
            };
            axios({
                method: 'POST',
                url: '/chat/t',
                withCredentials: true,
                data: JSON.stringify(thread),
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data) {
                        this.$router.push(`/messenger/${response.data.ID}`);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getAuthFlowConfig() {
            this.configLoading = true;
            axios
                .get(`/admin/signup-config/`)
                .then((response) => {
                    this.signupStrategy = response?.data?.signUpStrategy;
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.configLoading = false;
                });
        },
    },
};
